export interface PageChangedEvent {
  page: number;
  itemsPerPage?: number;
}
